import { formatInTimeZone as b } from "date-fns-tz";
import { useRef as D } from "react";
const Q = (e) => new Proxy({}, {
  get(t, n) {
    if (!(typeof globalThis > "u"))
      throw new Error(`You must implement the ${n} by wrapping the component inside <${e}.provider value={{${n}}} />`);
  }
}), X = 6048e5, ee = 864e5, y = 6e4, h = 36e5, w = Symbol.for("constructDateFrom");
function N(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && w in e ? e[w](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function o(e, t) {
  return N(t || e, e);
}
function U(e, t, n) {
  const r = o(e, n == null ? void 0 : n.in);
  return isNaN(t) ? N(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function $(e, t, n) {
  const r = o(e, n == null ? void 0 : n.in);
  return r.setTime(r.getTime() + t * y), r;
}
function I(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function x(e) {
  return !(!I(e) && typeof e != "number" || isNaN(+o(e)));
}
function A(e, t) {
  return +o(e) > +o(t);
}
function S(e, t) {
  return +o(e) == +o(t);
}
function C(e, t) {
  const n = () => N(t == null ? void 0 : t.in, NaN), i = M(e);
  let a;
  if (i.date) {
    const s = F(i.date, 2);
    a = O(s.restDateString, s.year);
  }
  if (!a || isNaN(+a)) return n();
  const f = +a;
  let c = 0, u;
  if (i.time && (c = W(i.time), isNaN(c)))
    return n();
  if (i.timezone) {
    if (u = Y(i.timezone), isNaN(u)) return n();
  } else {
    const s = new Date(f + c), g = o(0, t == null ? void 0 : t.in);
    return g.setFullYear(
      s.getUTCFullYear(),
      s.getUTCMonth(),
      s.getUTCDate()
    ), g.setHours(
      s.getUTCHours(),
      s.getUTCMinutes(),
      s.getUTCSeconds(),
      s.getUTCMilliseconds()
    ), g;
  }
  return o(f + c + u, t == null ? void 0 : t.in);
}
const m = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, j = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, v = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, R = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function M(e) {
  const t = {}, n = e.split(m.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], m.timeZoneDelimiter.test(t.date) && (t.date = e.split(m.timeZoneDelimiter)[0], r = e.substr(
    t.date.length,
    e.length
  ))), r) {
    const i = m.timezone.exec(r);
    i ? (t.time = r.replace(i[1], ""), t.timezone = i[1]) : t.time = r;
  }
  return t;
}
function F(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), r = e.match(n);
  if (!r) return { year: NaN, restDateString: "" };
  const i = r[1] ? parseInt(r[1]) : null, a = r[2] ? parseInt(r[2]) : null;
  return {
    year: a === null ? i : a * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function O(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const n = e.match(j);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], i = l(n[1]), a = l(n[2]) - 1, f = l(n[3]), c = l(n[4]), u = l(n[5]) - 1;
  if (r)
    return E(t, c, u) ? z(t, c, u) : /* @__PURE__ */ new Date(NaN);
  {
    const s = /* @__PURE__ */ new Date(0);
    return !_(t, a, f) || !k(t, i) ? /* @__PURE__ */ new Date(NaN) : (s.setUTCFullYear(t, a, Math.max(i, f)), s);
  }
}
function l(e) {
  return e ? parseInt(e) : 1;
}
function W(e) {
  const t = e.match(v);
  if (!t) return NaN;
  const n = p(t[1]), r = p(t[2]), i = p(t[3]);
  return P(n, r, i) ? n * h + r * y + i * 1e3 : NaN;
}
function p(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function Y(e) {
  if (e === "Z") return 0;
  const t = e.match(R);
  if (!t) return 0;
  const n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
  return V(r, i) ? n * (r * h + i * y) : NaN;
}
function z(e, t, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const i = r.getUTCDay() || 7, a = (t - 1) * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + a), r;
}
const Z = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function T(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function _(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (Z[t] || (T(e) ? 29 : 28));
}
function k(e, t) {
  return t >= 1 && t <= (T(e) ? 366 : 365);
}
function E(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function P(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function V(e, t) {
  return t >= 0 && t <= 59;
}
const H = new RegExp("^(?:[a-z]+:)?//", "i");
function te(e) {
  return H.test(e);
}
function L(e) {
  return typeof e == "number";
}
function q(e) {
  return typeof e == "string";
}
function ne(e) {
  try {
    return new URL(e), !0;
  } catch {
    return !1;
  }
}
function re(e, t) {
  return U(d(e), t);
}
function ie(e, t) {
  return $(d(e), t);
}
function se(e, t = "d MMM yyyy - h:mma", n = "Asia/Hong_Kong") {
  return b(d(e), n, t);
}
function ae(e, t) {
  const n = d(e), r = d(t);
  return A(n, r) || S(n, r);
}
function J(e) {
  return x(e);
}
function d(e) {
  if (q(e)) {
    const t = C(e);
    return J(t) ? t : new Date(e);
  } else if (L(e))
    return new Date(e);
  return e;
}
const oe = () => {
  const e = D(() => {
  }), t = D(() => {
  }), n = D(null);
  return n.current ?? (n.current = new Promise((r, i) => {
    e.current = r, t.current = i;
  })), {
    promise: n,
    reject: t,
    resolve: e
  };
};
function ce() {
  return typeof navigator > "u" ? !1 : /fban|fbav/i.test(navigator.userAgent);
}
const ue = (e, t) => {
  try {
    localStorage.setItem(e, t);
  } catch {
  }
};
function fe(...e) {
  var t, n;
  return (t = (n = e.find((r) => {
    var i;
    return (i = r == null ? void 0 : r.length) !== null && i !== void 0 ? i : !1;
  })) === null || n === void 0 ? void 0 : n.trim()) !== null && t !== void 0 ? t : "";
}
function le() {
  const e = new RegExp("(" + ["WebView", "(iPhone|iPod|iPad)(?!.*Safari)", String.raw`Android.*(;\s+wv|Version/\d.\d\s+Chrome/\d+(\.0){3})`, "Linux; U; Android"].join("|") + ")", "ig"), t = B();
  return e.test(t);
}
function de() {
  return typeof globalThis > "u" ? null : globalThis;
}
function me(e) {
  return !(e == null || e === "" || e === "0" || e === 0 || e === !1 || typeof e == "object" && Object.keys(e).length === 0);
}
function ge(e) {
  return e.replaceAll("@media", "").trim();
}
function De(e) {
  try {
    return e ? JSON.parse(e) : {};
  } catch {
    return {};
  }
}
function pe(...e) {
  const t = /* @__PURE__ */ new Set();
  return [...e].flat().filter((n) => t.has(n) ? !1 : t.add(n));
}
function B() {
  return typeof navigator == "object" && "userAgent" in navigator ? navigator.userAgent : typeof process == "object" && process.version !== void 0 ? `Node.js/${process.version.slice(1)} (${process.platform}; ${process.arch})` : "<environment undetectable>";
}
export {
  x as A,
  U as B,
  de as a,
  De as b,
  Q as c,
  re as d,
  ie as e,
  fe as f,
  le as g,
  se as h,
  ae as i,
  J as j,
  oe as k,
  te as l,
  L as m,
  me as n,
  q as o,
  d as p,
  ne as q,
  ge as r,
  ue as s,
  ce as t,
  pe as u,
  o as v,
  N as w,
  ee as x,
  y,
  X as z
};
//# sourceMappingURL=index-ByKJWKwE.mjs.map
